// extracted by mini-css-extract-plugin
module.exports = {"footer":"ServiceAddressAside_footer__eQxZ3","container":"ServiceAddressAside_container__t1kXW"};